import React, { PureComponent } from 'react';
// eslint-disable-next-line import/extensions
import yaml from 'js-yaml';
import PropTypes from 'prop-types';
import { Modal } from 'antd';
import TextArea from 'antd/lib/input/TextArea';
import { Col, Row } from 'reactstrap';
import NFButton from '../../primitives/NFButton';

class ViewCapabilities extends PureComponent {
  static propTypes = {
    capabilities: PropTypes.any.isRequired,
    association: PropTypes.string.isRequired,
    showCapModal: PropTypes.bool.isRequired,
    closeCapModal: PropTypes.func.isRequired,
  };

  render() {
    const { showCapModal, closeCapModal, capabilities, association } = this.props;
    const caps = {}
    if (capabilities) {
      Object.keys(capabilities).forEach(key => {
        const cap = capabilities[key];
        if (Array.isArray(cap)) {
          if (cap.length !== 0) {
            caps[key] = cap;
          }
        } else if (cap !== '') {
          caps[key] = cap;
        }
      });
    }

    return (
      <div className="nf-add-organization">
        <Modal
          title={<h2>{association} Capabilities</h2>}
          visible={showCapModal}
          width="fit-content"
          footer={null}
          onCancel={closeCapModal}
        >
          <Row>
            <Col>
              <TextArea
                rows={25}
                cols={60}
                value={yaml.dump(caps, { indent: 4, lineWidth: -1 })}
              />
            </Col>
          </Row>
          <br />
          <Row>
            <Col sm={{ size: 7, offset: 5 }} className="text-center">
              <NFButton
                className="nf-button--gray-border"
                onClick={() => {
                  closeCapModal();
                }}
              >
                Cancel
              </NFButton>
            </Col>
          </Row>
        </Modal>
      </div>
    );
  }
}

export default ViewCapabilities;



// WEBPACK FOOTER //
// ./src/components/Modals/ViewCapabilities/ViewCapabilities.jsx